// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"fc81f2b9","290":"08d5e1e8","496":"0b494aea","722":"186e3727","765":"1d459bef","843":"3f267067"}[chunkId] + ".chunk.js";
};